<template>
  <div class="modal" v-if="modal.status" @click="closeModal()">
    <div @click.stop="">
      <component :is="modal.component"></component>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Details from '@/components/Details'
import Conflicts from '@/components/Conflicts'
export default {
  components: {
    Details,
    Conflicts,
  },
  computed: {
    ...mapGetters(['modal'])
  },
  methods: {
    ...mapMutations(['closeModal']),
    handleKeyDown(event) {
      if (event.keyCode === 27) {
        event.preventDefault();
        this.closeModal();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>